import { Pipe, PipeTransform } from '@angular/core';

import { TranslationService } from '../services/translation.service';

type DropdownOption<T> = Record<string, T>;

@Pipe({
	name: 'copoSortOptions',
})
export class SortOptionsPipe<T> implements PipeTransform {
	constructor(private readonly translationservice: TranslationService) {}
	transform(
		options: DropdownOption<T>[] | undefined,
		translationRequired: boolean,
		config: {
			codeProp: keyof DropdownOption<T>;
			valueProp: keyof DropdownOption<T>;
		},
		defaultCode?: string,

	): DropdownOption<T>[] {
		if (!options || options.length === 0) {
			return [];
		}

		// initializing sorted option variable
		const sortedOptions = options.filter(option => option[config.codeProp]);

		// checking  translation are required  or not in dropdown option
		let clonedSortedOptions = translationRequired ? sortedOptions.map(obj => ({ ...obj }))
			: sortedOptions;

		if (translationRequired) {
			for (const data of clonedSortedOptions) {
				data[config.valueProp] = <T> this.translationservice.getTR(<string>data[config.valueProp]);
			}
		}

		// Sort the options alphabetically
		clonedSortedOptions.sort((a, b) => String(a[config.valueProp]).localeCompare(
			String(b[config.valueProp])
		));

		// Find the default option
		if (defaultCode) {
			// Remove the default option from the list if any default code
			clonedSortedOptions = clonedSortedOptions.filter(option => option[config.codeProp] !== defaultCode);

			const defaultOption = clonedSortedOptions.find(option => option[config.codeProp] === defaultCode);
			if (defaultOption) {
				clonedSortedOptions.unshift(defaultOption);
			}
		}
		return clonedSortedOptions;
	}
}
